import { isConnectSplashType } from "../../../data/connectSplashConfig";
import styles from "./AdminShared.module.css";

/** Preview cluster for editor / create toolbars. Splash uses a segmented pair. */
export default function AdminPreviewActions({
  type,
  onPreview,
  disabled,
  included = false,
  onToggleInclude,
  includeCount = 0,
}) {
  const includeButton = onToggleInclude ? (
    <button
      type="button"
      className={
        included
          ? `${styles["btn-secondary"]} ${styles["btn-include-on"]}`
          : styles["btn-ghost"]
      }
      aria-pressed={included}
      onClick={onToggleInclude}
      disabled={disabled}
      title={
        included
          ? "Remove this item from the preview set"
          : "Add this item to the preview set without opening a tab"
      }
    >
      {included
        ? includeCount > 1
          ? `Included · ${includeCount}`
          : "Included"
        : "Include"}
    </button>
  ) : null;

  if (isConnectSplashType(type)) {
    return (
      <div className={styles["action-group"]} role="group" aria-label="Preview">
        <span className={styles["action-group-label"]}>Preview</span>
        {includeButton}
        <div className={styles.segmented}>
          <button
            type="button"
            className={styles["segmented-btn"]}
            onClick={() => onPreview("pending")}
            disabled={disabled}
          >
            Pending
          </button>
          <button
            type="button"
            className={styles["segmented-btn"]}
            onClick={() => onPreview("confirmed")}
            disabled={disabled}
          >
            Confirmed
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles["action-group"]} role="group" aria-label="Preview">
      {includeButton}
      <button
        type="button"
        className={styles["btn-secondary"]}
        onClick={() => onPreview()}
        disabled={disabled}
      >
        Preview
      </button>
    </div>
  );
}
